import {
  orderPlant
} from '@/api/oli_api'

const state = {
  opdOilCode: null,
  opdLoading: false,
  oilHisJxcDatas: [],
  opdOilDetail: {
    map: {},
    orderList: {}
  }
}

const getters = {
  opdOilCode: state => state.opdOilCode,
  opdOilDetail: state => state.opdOilDetail,
  opdLoading: state => state.opdLoading,
  oilHisJxcDatas: state => state.oilHisJxcDatas
}

const actions = {
  setOpdOilCode ({ commit, dispatch, getters }, data) {
    commit('setOpdOilCode', data)
    dispatch('filtOilHisJxcDatas', data)
    if (getters.opdLoading) {
      return
    }
    dispatch('setOilDetail', {
      map: {},
      orderList: {}
    })
    if (data) {
      commit('setOpdLoading', true)
      let parm = {
        action: 'get_oil_ps_detail',
        data: {
          oil_code: data
        }
      }
      orderPlant(parm).then((data) => {
        if (data.code === '-1') {
          commit('setOpdLoading', false)
          return
        }
        dispatch('setOilDetail', {map: data['oilDetail'] || {}, orderList: data['orderList'] || {}})
        commit('setOpdLoading', false)
      }).catch((e) => {
        commit('setOpdLoading', false)
      })
    }
  },
  filtOilHisJxcDatas ({ commit, getters }, data) {
    if (!data) {
      return
    }
    let datas = []
    getters.hisJxcDatas.forEach((itemA) => {
      itemA.data.forEach((item) => {
        if (item['油站代码'] === data) {
          datas.push(item)
        }
      })
    })
    commit('setOilHisJxcDatas', datas)
  },
  setOilDetail ({ commit }, data) {
    commit('setOpdOilDetail', data)
  },
  setOpdLoading ({ commit }, data) {
    commit('setOpdLoading', data)
  }
}

const mutations = {
  setOilHisJxcDatas (state, data) {
    state.oilHisJxcDatas = data
  },
  setOpdOilCode (state, data) {
    state.opdOilCode = data
  },
  setOpdOilDetail (state, data) {
    state.opdOilDetail = data
  },
  setOpdLoading (state, data) {
    state.opdLoading = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oil/oil_ps_detail.js